"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _underscore = require("underscore");
var _ApproveAs = _interopRequireDefault(require("../KnockTypeButtons/ApproveAs/ApproveAs"));
var _ActionItemTooltip = _interopRequireDefault(require("../ActionItemTooltip/ActionItemTooltip"));
var _Deny = _interopRequireDefault(require("../KnockTypeButtons/Deny/Deny"));
var _KnockItemFooter = require("./KnockItemFooter.styled");
var _KnockTypes = require("../../../../constants/KnockTypes");
var _hooks = require("../../../../hooks");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _useTranslate2 = require("../../../../locales/useTranslate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var logger = new _StudioLogger.StudioLogger('ApproveAs');
var voidy = function voidy() {};
var KnockItemFooter = function KnockItemFooter(_ref) {
  var knockId = _ref._id,
    type = _ref.type,
    presenterName = _ref.presenterName,
    _ref$sources = _ref.sources,
    sources = _ref$sources === void 0 ? [] : _ref$sources,
    _ref$allSources = _ref.allSources,
    allSources = _ref$allSources === void 0 ? [] : _ref$allSources,
    onApprove = _ref.onApprove,
    onDeny = _ref.onDeny,
    onAssignKnockToSource = _ref.onAssignKnockToSource,
    isDisabled = _ref.isDisabled,
    assignedSourceId = _ref.sourceId;
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var debouncedApprove = (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(function () {
      logger.info("Approve button clicked for speaker: ".concat(presenterName), {
        speakerData: {
          action: 'approve',
          name: presenterName
        }
      });
      onApprove();
    }, 500, {
      leading: true,
      trailing: false
    });
  }, [presenterName, onApprove]);
  (0, _react.useEffect)(function () {
    return function () {
      debouncedApprove.cancel();
    };
  }, [debouncedApprove]);
  var handleApprove = (0, _react.useCallback)(function () {
    debouncedApprove();
  }, [debouncedApprove]);
  var isButtonDisabled = isDisabled;
  var handleAssignKnockToSource = (0, _react.useCallback)(function (sourceId) {
    onAssignKnockToSource && onAssignKnockToSource(sourceId);
  }, [onAssignKnockToSource]);
  var getToolTipMessage = function getToolTipMessage() {
    return isButtonDisabled ? translate('ScreenShareCount_Popover') : translate('KnockApproveButton_Popover');
  };
  var actionItemTooltipMessage = getToolTipMessage();
  return /*#__PURE__*/_react["default"].createElement(_KnockItemFooter.KnockItemFooterContainer, {
    isStudioLite: isStudioLite,
    key: knockId
  }, [_KnockTypes.CAMERA].includes(type) ? /*#__PURE__*/_react["default"].createElement(_ActionItemTooltip["default"], {
    target: "speak-request-".concat(knockId),
    message: actionItemTooltipMessage,
    placement: "bottom"
  }, /*#__PURE__*/_react["default"].createElement(_KnockItemFooter.StyledButton, {
    color: "primary",
    onClick: handleApprove,
    id: "speak-request-".concat(knockId),
    $isDisabled: isButtonDisabled
  }, "Approve")) : !isStudioLite ? /*#__PURE__*/_react["default"].createElement(_ActionItemTooltip["default"], {
    target: "approve-as-".concat(knockId),
    message: getToolTipMessage(),
    key: "approve-as-tooltip-".concat(knockId)
  }, /*#__PURE__*/_react["default"].createElement(_ApproveAs["default"], {
    key: knockId,
    assignedSourceId: assignedSourceId,
    sources: sources,
    allSources: allSources,
    onApprove: onApprove,
    name: presenterName,
    knockType: type,
    onAssignKnockToSource: handleAssignKnockToSource,
    elementId: "approve-as-".concat(knockId),
    isDisabled: isButtonDisabled
  })) : /*#__PURE__*/_react["default"].createElement(_ActionItemTooltip["default"], {
    target: "approve-".concat(knockId),
    message: actionItemTooltipMessage,
    placement: "bottom"
  }, /*#__PURE__*/_react["default"].createElement(_KnockItemFooter.StyledButton, {
    "data-testid": "approve-".concat(presenterName, "-").concat(knockId),
    color: "primary",
    onClick: isDisabled ? voidy : handleApprove,
    id: "approve-".concat(knockId),
    $isDisabled: isButtonDisabled
  }, "Approve")), /*#__PURE__*/_react["default"].createElement(_ActionItemTooltip["default"], {
    target: "deny-button-".concat(knockId),
    message: translate('KnockDenyButton_Popover'),
    noPointerEvent: true
  }, /*#__PURE__*/_react["default"].createElement(_Deny["default"], {
    onDeny: onDeny,
    elementId: "deny-button-".concat(knockId)
  })));
};
KnockItemFooter.propTypes = {
  _id: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].string.isRequired,
  presenterName: _propTypes["default"].string,
  sources: _propTypes["default"].array,
  allSources: _propTypes["default"].array,
  onApprove: _propTypes["default"].func.isRequired,
  onDeny: _propTypes["default"].func.isRequired,
  maxCamerasExceeded: _propTypes["default"].bool,
  socketId: _propTypes["default"].string,
  onAssignKnockToSource: _propTypes["default"].func,
  isDisabled: _propTypes["default"].bool,
  sourceId: _propTypes["default"].string
};
var _default = exports["default"] = KnockItemFooter;